"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeShortPassword = void 0;
const common_1 = require("@affinidi/common");
const _defaultConfig_1 = require("../_defaultConfig");
exports.normalizeShortPassword = (password, userName) => {
    if (password.length < _defaultConfig_1.MINIMUM_RECOMMENDED_PASSWORD_LENGTH) {
        const userNameBuffer = common_1.KeysService.sha256(Buffer.from(userName));
        const userNameHash = userNameBuffer.toString('hex');
        password = `${password}${userNameHash}A!`;
    }
    return password;
};
//# sourceMappingURL=normalizeShortPassword.js.map